import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="section-header">
          <h2 className="section-title">About Us</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Excellence in Every Endeavor</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Welcome to Sami Rafael LLC</h3>
            <p>
              At Sami Rafael, we are committed to delivering exceptional business solutions 
              tailored to meet the unique needs of our clients. With years of experience and 
              a dedicated team of professionals, we have established ourselves as a trusted 
              partner in the industry.
            </p>
            <p>
              Our company is built on a foundation of integrity, innovation, and excellence. 
              We believe in creating long-lasting relationships with our clients by providing 
              reliable services and maintaining the highest standards of professionalism.
            </p>
            <p>
              Led by experienced managers including Nikola Baovic, João Pereira and Mihajlo Stanojevic, our team brings together 
              diverse expertise and a shared commitment to your success. We understand the challenges 
              businesses face today and are here to help you navigate them with confidence.
            </p>

            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Professional Excellence</h4>
                  <p>Committed to delivering the highest quality service</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Trusted Partnership</h4>
                  <p>Building lasting relationships based on trust and reliability</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Innovative Solutions</h4>
                  <p>Leveraging the latest approaches to solve your challenges</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-stats">
            <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">∞</div>
              <div className="stat-label">Commitment to Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

